/** FE window size for right-panel tray thumbs — the Photos API returns full lists without pagination (WMPCM-1999). */
export const TRAY_LAZY_CHUNK_SIZE = 10

/** Use one column when total filtered results are ≤ this count; otherwise two columns. */
export const TRAY_SINGLE_COLUMN_MAX = 10

/** One column for up to `singleColumnMax` results (the tray default unless a tray sets its own),
 *  two beyond that. */
export function trayColumnCount(
  totalFilteredCount: number,
  singleColumnMax = TRAY_SINGLE_COLUMN_MAX
): 1 | 2 {
  return totalFilteredCount <= singleColumnMax ? 1 : 2
}

export function nextTrayVisibleCount(
  currentVisible: number,
  totalFilteredCount: number,
  chunkSize = TRAY_LAZY_CHUNK_SIZE
): number {
  if (totalFilteredCount <= 0) return chunkSize

  return Math.min(totalFilteredCount, currentVisible + chunkSize)
}

export function sliceTrayWindow<T>(items: T[], visibleCount: number): T[] {
  if (visibleCount <= 0) return []

  return items.slice(0, visibleCount)
}
